export default __webpack_public_path__ + "static/media/gallery_00.d0f2a38b.jpg";